// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1_esbuild@0.27.2_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::-webkit-scrollbar {
  display: none;
}

.story-list {
  padding: 16px 0 8px;
  border-bottom: 1px solid #ddd;
}
.story-list .scroll-horizontal {
  padding-left: 16px;
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}
.story-list .scroll-horizontal .scroll-item {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  margin-right: 18px;
  margin-bottom: 8px;
  text-align: center;
  align-items: center;
}
.story-list .scroll-horizontal .item-label {
  font-size: 13px;
  margin-top: 8px;
}
.story-list .scroll-horizontal .avatar-md {
  width: 55px;
  height: 55px;
  cursor: pointer;
}
.story-list .scroll-horizontal .logo-img {
  height: 100%;
  width: 100%;
  object-fit: fill;
}
.story-list .scroll-horizontal ion-avatar.has-update {
  padding: 2px;
  border: 2px solid var(--ion-color-secondary-shade);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/usefull-links/links/links.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,mBAAA;EACA,6BAAA;AACF;AACE;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iCAAA;AACJ;AACI;EACE,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AACN;AAEI;EACE,eAAA;EACA,eAAA;AAAN;AAGI;EACE,WAAA;EACA,YAAA;EACA,eAAA;AADN;AAGI;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AADN;AAKM;EACE,YAAA;EACA,kDAAA;AAHR","sourcesContent":["::-webkit-scrollbar {\n  display: none;\n}\n\n.story-list {\n  padding: 16px 0 8px;\n  border-bottom: 1px solid #ddd;\n\n  .scroll-horizontal {\n    padding-left: 16px;\n    white-space: nowrap;\n    overflow-x: scroll;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n\n    .scroll-item {\n      position: relative;\n      display: inline-flex;\n      flex-direction: column;\n      margin-right: 18px;\n      margin-bottom: 8px;\n      text-align: center;\n      align-items: center;\n    }\n\n    .item-label {\n      font-size: 13px;\n      margin-top: 8px;\n    }\n\n    .avatar-md {\n      width: 55px;\n      height: 55px;\n      cursor: pointer;\n    }\n    .logo-img {\n      height: 100%;\n      width: 100%;\n      object-fit: fill;\n    }\n\n    ion-avatar {\n      &.has-update {\n        padding: 2px;\n        border: 2px solid var(--ion-color-secondary-shade);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
